import { Component } from '@angular/core';

@Component({
  selector: 'app-lotacoes-vinculadas-cadastro',
  templateUrl: './lotacoes-vinculadas-cadastro.component.html',
  styleUrls: ['./lotacoes-vinculadas-cadastro.component.css']
})
export class LotacoesVinculadasCadastroComponent {

}
